module.exports = __webpack_public_path__ + "static/media/signal-alt-2.246a6587.svg";